
export default {
  lifeInsurance: {
    title: 'Vos contrats d\'assurance-vie (y compris épargne retraite)',
    subtitle: 'Sélectionner un contrat pour voir le détail',
    help: 'L\'assurance vie est une technique de transmission du patrimoine. Le capital versé au décès de l\'assuré au bénéficiaire désigné ne fait pas partie de la succession.',
  },
  patrimonyTransmission: {
    drawer: {
      title: 'Votre patrimoine à transmettre',
      lifeInsurance: {
        description: 'Veuillez mettre à jour les informations relatives à vos contrats.',
        inputs: {
          date: 'Date de mise à jour',
          beneficiaryClause: 'Clause bénéficiaire',
          input757BLabel: 'Compartiment 757B',
          input990ILabel: 'Compartiment 990I',
          inputExoneratedLabel: 'Compartiment Exonéré',
        },
        sections: {
          beneficiaryClause: 'Clause bénéficiaire',
          taxes: 'Fiscalité',
          beneficiaries: 'Bénéficiaires',
        },
        couple: 'Couple',
        informationMessage: {
          why: 'À quoi servent ces données ?',
        },
      },
      patrimony: {
        description: 'Veuillez sélectionner, ci-dessous, vos avoirs communs ou en indivision.',
        inputs: {
          holdersName: 'Nom des détenteurs',
          fullOwnershipPct: '% Pleine propriété',
          usufruitPct: '% Usufruit',
          barePropertyPct: '% Nue-Propriété',
          community: 'Communauté'
        },
        sections: {
          all: 'Tout le patrimoine'
        },
        informationMessage: {
          why: 'En savoir plus :',
          content: {
            community: 'Dans le cadre d\'un régime de communauté, chaque époux est propriétaire de ses biens propres et des biens communs considérés comme appartenant aux deux époux. En principe, les biens acquis pendant le mariage sont considérés comme des biens communs des époux, y compris lorsqu\'ils l\'ont été au moyen des gains, salaires et revenus de leurs biens propres. Par exception, les biens acquis via transmission ou en remploi de biens propres restent des biens propres.',
            acquests_society: 'Dans le cadre d\'un régime de séparation de biens avec société d\'acquêts, chaque époux  conserve son indépendance patrimoniale, tout en mettant en commun certains biens personnels. En pratique, la société d\'acquêts est une clause particulière du contrat de mariage permettant de créer une masse commune de biens. Les biens qui la composent sont soumises aux règles du régime matrimonial légal de la communauté réduite aux acquêts.',
            indivision: 'Dans le cadre d\'un régime de pacs en indivision, les biens acquis par les partenaires postérieurement à l\'enregistrement du pacs, hors cas d\'emploi de deniers propres, sont indivis par moitié entre chaque partenaire. En pratique, les biens indivis sont la propriété des deux partenaires à parts égales, qu\'ils aient été financés intégralement par l\'un ou l\'autre ou à parts égales entre les partenaires.',
          }
        },
        community: 'Communauté',
        indivision: 'Indivision',
      },
      tabs: {
        lifeInsurance: 'Assurance-vie',
        patrimony: 'Patrimoine',
      },
    },
  },
  patrimonyRepartition: {
    title: 'Repartition du patrimoine',
    subtitle: 'Sur la base des éléments renseignés',
    helpMessage: {
      asv: 'Vos biens composant l\'actif successoral et les capitaux décès des contrats d\'assurance-vie subissent un traitement juridique et fiscal différent dans le cadre de la transmission.\nDans le cadre de la transmission, les capitaux décès des contrats d\'assurance-vie subissent un traitement juridique et fiscal différent des biens composant l\'actif successoral. En effet, ces capitaux décès sont versés à un ou des bénéficiaires que vous désignez et bénéficient d\'une fiscalité attractive.',
      common: 'La répartition du patrimoine dans le couple est est révélateur des actions à mener pour améliorer la protection du conjoint et l\'optimisation de la transmission.',
      liquid: 'Les droits de succession sont à régler dans les 6 mois du décès. En l\'absence de liquidité, vos héritiers pourraient être amenés à vendre des biens du patrimoine familial dans la précipitation pour respecter cette échéance.',
    },
    view: {
      commonGraph: {
        common: 'Patrimoine commun',
        indivision: 'Patrimoine en indivision',
        own: 'Patrimoine {name}',
        default: 'Patrimoine total',
      },
      liquidGraph: {
        liquidCommon: 'Actifs liquides commun',
        liquidOwn: 'Actifs liquides {name}',
        illiquidCommon: 'Actifs illiquides commun',
        illiquidOwn: 'Actifs illiquides {name}',
      },
      asvGraph: {
        asvCommon: 'Assurance-vie commune',
        asvOwn: 'Assurance-vie {name}',
        inheritanceAssetCommon: 'Actif successoral commun',
        inheritanceAssetOwn: 'Actif successoral {name}',
      },
    },
    options: {
      common: 'Répartition au sein du couple',
      liquid: 'Liquidité du patrimoine',
      asv: 'Part de l\'assurance-vie',
    }
  },
  protection: {
    drawer: {
      title: 'Prévoyance et protection',
      description: 'Veuillez mettre à jour les informations relatives à vos contrats de prévoyance',
      inputs: {
        date: 'Date de mise à jour',
        beneficiaryClause: 'Clause bénéficiaire',
      }
    },
  },
  dispositions: {
    drawer: {
      title: 'Vos Dispositions',
      donations: {
        description: 'Veuillez renseigner ci-dessous les informations liées à vos donations et legs :',
        add: 'Ajouter une donation',
        inputs: {
          date: 'Date de la donation',
          donator: 'Donateur',
          nature: 'Nature de donation',
          type: 'Type de donation',
          mode: 'Mode de donation',
        },
        sections: {
          header: 'Renseigner une donation',
          mainInformations: 'Informations principales',
          donators: 'Donataires',
          donationAmounts: 'Montants de la donation',
          donationDescription: 'Description de la donation'
        },
        informationMessage: {
          why: 'Pourquoi renseigner les donations effectuées ?',
          content: `Les donations réalisées à vos enfants dans les 15 dernières années sont prises en compte dans le calcul des droits de succession.`,
        }
      },
      legs: {
        description: 'Veuillez renseigner ci-dessous les informations liées à vos donations et legs :',
        add: 'Ajouter un legs',
        inputs: {
          date: 'Date d\'effet',
          attributor: 'Légateur',
          type: 'Type de legs',
        },
        sections: {
          header: 'Renseigner un legs',
          mainInformations: 'Informations principales',
          receivers: 'Légataires',
          legAmounts: 'Montants des legs',
          legDescription: 'Description du legs'
        },
        informationMessage: {
          why: 'Pourquoi renseigner les legs effectués ?',
          content: `Le legs est une disposition prise par testament pour désigner un ou plusieurs bénéficiaires de la succession.`,
        }
      },
      tabs: {
        donations: 'Donations',
        legs: 'Legs',
      },
      actionButtons: {
        cancel: 'Annuler',
        save: 'Enregistrer',
      }
    }
  },
  sections: {
    situation: {
      title: 'Votre situation familiale',
      hint: 'Votre statut marital et votre situation familiale sont déterminants pour la préparation de votre transmission.'
    },
    patrimony: {
      title: 'Votre patrimoine à transmettre'
    },
    protection: {
      title: 'Prévoyance et protection au sein du foyer familial',
      hint: 'Il est important de vous assurer que vos proches puissent faire face aux conséquences et aux dépenses liées à votre décès : le remboursement de vos crédits, le financement de vos obsèques et droits de succession, et le maintien de leur niveau de vie.'
    }
  }
}
